import React from 'react';

import ClassNames from 'classnames';
import styles from './scroll-button.css';


class ScrollButton extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            isOpen:this.props.turbo
        }
        this.downbutton = this.downbutton.bind(this)
    }

    downbutton (){
        var isOpen = !this.state.isOpen
        this.props.vm.setTurboMode(isOpen)
        this.setState({
            isOpen:isOpen
        })
    }
    render (){
        return (
            <div className={ClassNames(styles.scrollButtonBox,{[styles.buttonBoxOpen]: this.state.isOpen})}
                onClick={this.downbutton}
            >
                <div className={ClassNames(styles.scrollButtonIcon,{[styles.buttonIconOpen]: this.state.isOpen})}></div>
            </div>
        )
    }
}

export default ScrollButton